// 向上取整函数
export default (number: number, decimalPlaces = 2) => {
  const factor = Math.pow(10, decimalPlaces);
  return Math.ceil(Number((number * factor).toFixed(0))) / factor;
}